__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "SkynamoAnalyticsDashboard";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@influxdata/influxdb-client-browser", "1.35.0", () => (__webpack_require__.e("vendors-node_modules_influxdata_influxdb-client-browser_dist_index_browser_mjs").then(() => (() => (__webpack_require__("./node_modules/@influxdata/influxdb-client-browser/dist/index.browser.mjs"))))));
			register("@vueuse/core", "10.11.1", () => (Promise.all([__webpack_require__.e("vendors-node_modules_vueuse_core_index_mjs"), __webpack_require__.e("webpack_sharing_consume_default_vue-demi_vue-demi")]).then(() => (() => (__webpack_require__("./node_modules/@vueuse/core/index.mjs"))))));
			register("axios", "1.13.2", () => (__webpack_require__.e("vendors-node_modules_axios_index_js").then(() => (() => (__webpack_require__("./node_modules/axios/index.js"))))));
			register("dexie", "3.2.7", () => (__webpack_require__.e("vendors-node_modules_dexie_dist_modern_dexie_min_mjs").then(() => (() => (__webpack_require__("./node_modules/dexie/dist/modern/dexie.min.mjs"))))));
			register("moment", "2.30.1", () => (Promise.all([__webpack_require__.e("vendors-node_modules_moment_locale_af_js-node_modules_moment_locale_ar-dz_js-node_modules_mom-582c96"), __webpack_require__.e("node_modules_moment_locale_sync_recursive_")]).then(() => (() => (__webpack_require__("./node_modules/moment/moment.js"))))));
			register("pinia", "3.0.4", () => (Promise.all([__webpack_require__.e("vendors-node_modules_pinia_dist_pinia_mjs"), __webpack_require__.e("webpack_sharing_consume_default_vue_vue")]).then(() => (() => (__webpack_require__("./node_modules/pinia/dist/pinia.mjs"))))));
			register("vue-demi", "0.14.10", () => (Promise.all([__webpack_require__.e("webpack_sharing_consume_default_vue_vue"), __webpack_require__.e("node_modules_vue-demi_lib_index_mjs")]).then(() => (() => (__webpack_require__("./node_modules/vue-demi/lib/index.mjs"))))));
			register("vue-router", "4.6.3", () => (Promise.all([__webpack_require__.e("vendors-node_modules_vue-router_dist_vue-router_mjs"), __webpack_require__.e("webpack_sharing_consume_default_vue_vue")]).then(() => (() => (__webpack_require__("./node_modules/vue-router/dist/vue-router.mjs"))))));
			register("vue3-click-away", "1.2.4", () => (__webpack_require__.e("node_modules_vue3-click-away_dist_module_js").then(() => (() => (__webpack_require__("./node_modules/vue3-click-away/dist/module.js"))))));
			register("vue", "3.5.25", () => (__webpack_require__.e("vendors-node_modules_vue_dist_vue_runtime_esm-bundler_js").then(() => (() => (__webpack_require__("./node_modules/vue/dist/vue.runtime.esm-bundler.js"))))));
			initExternal("webpack/container/reference/SkynamoDesignSystem");
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};